<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48 19.84a34.09 34.09 0 1 1 -34.08 34.09 34.12 34.12 0 0 1 34.08-34.09m0-4a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09z"
      fill="#4f2b1b"
    />
    <path
      d="m63.82 33.16c-2.29-3.93-5.4-6.45-10-6.82-1.34-.11-3.29-.44-4.46.41a3 3 0 0 0 -.96 1.25 19.44 19.44 0 0 0 -1.76-4.13.78.78 0 0 0 -1.35.79 19.57 19.57 0 0 1 2.27 6.62c-3.29.32-5.05 3.12-6.19 6.06s-1.65 5-3.74 7.34a9.66 9.66 0 0 0 -2.63 5.09c-.19 1 1.33 1.42 1.51.42.65-3.42 3.3-4.63 4.72-7.5 1.77-3.53 1.77-9.69 6.92-9.82 5.6-.12 5.15 6 5 9.84-.15 3.07 1.9 4.92 2.58 7.87.23 1 1.74.57 1.52-.42-.55-2.37-2.49-4.43-2.6-6.83-.11-2.23.51-4.39 0-6.64a6.53 6.53 0 0 0 -5.25-5.38c.12-1.72.51-3.06 2.52-3.47a10.08 10.08 0 0 1 3.42.27 10.26 10.26 0 0 1 6.56 4.89c-3.72.71-6.86-.7-9.31-3.74-.63-.79-1.74.33-1.11 1.11a10.72 10.72 0 0 0 11.87 3.91.8.8 0 0 0 .47-1.12z"
      fill="#4f2b1b"
    />
    <path
      d="m48.79 58.89a16.76 16.76 0 0 1 -3.79-.16c-1-.15-1.41 1.36-.41 1.52a18.62 18.62 0 0 0 4.22.21c.99-.06.99-1.63-.02-1.57z"
      fill="#4f2b1b"
    />
    <path
      d="m49.47 46.28-.21-.21-.18.22a3.39 3.39 0 0 0 -.72 2c0 1 .42 2 1.06 2 .65 0 1-1.09.91-2.13a3.37 3.37 0 0 0 -.86-1.88zm0 3.57c-.14 0-.49-.54-.53-1.55a2.56 2.56 0 0 1 .41-1.41 2.61 2.61 0 0 1 .52 1.37c0 1.02-.31 1.58-.45 1.59z"
      fill="#4f2b1b"
    />
    <path
      d="m45.05 47.53a3.35 3.35 0 0 0 .29-2.14l-.06-.28-.28.09a3.38 3.38 0 0 0 -1.68 1.34c-.51.91-.74 2-.17 2.31a.51.51 0 0 0 .29.08c.56 0 1.17-.65 1.61-1.4zm-1.64.87c-.12-.07-.14-.71.37-1.6a2.56 2.56 0 0 1 1.09-1 2.54 2.54 0 0 1 -.28 1.44c-.5.91-1.07 1.23-1.18 1.16z"
      fill="#4f2b1b"
    />
    <g fill="#42210b">
      <circle
        cx="27.3"
        cy="64.6"
        r=".84"
      />
      <circle
        cx="33.08"
        cy="60.71"
        r=".84"
      />
      <circle
        cx="38.48"
        cy="56.77"
        r=".84"
      />
      <circle
        cx="38.74"
        cy="62.79"
        r=".84"
      />
      <circle
        cx="32.45"
        cy="67.39"
        r=".84"
      />
      <circle
        cx="39"
        cy="68.81"
        r=".84"
      />
    </g>
    <path
      d="m45.5 59.62c-1.21-4.57-5.26-9.2-10.06-10.13a5.58 5.58 0 0 0 1.25-4.49.85.85 0 0 0 -1.23-.5c-2 1-5.19 4.22-7.53 3.83-1.05-.17-1.51 1.44-.45 1.61 2.75.45 5.29-1.76 7.62-3.28-.38 2.09-2.82 3.61-4.29 4.69-.52.39-1 .4-1.22 1.09a.85.85 0 0 0 .21.82c1 .91 2.87 1.25 4.4 1.59a5 5 0 0 1 -6.05 1.15.86.86 0 0 0 -1.23.5c-1 2.86-2.9 4.45-5.53 4.37a10.81 10.81 0 0 0 1.45-3.21c.21-.56-.32-1-.8-1.06a3.56 3.56 0 0 1 -2.88-1.6c2.86-.43 8.1-1.37 7.51-4.59-.51-2.74-5.06-4.33-7.19-5.32-1-.45-1.82 1-.85 1.44 1.76.82 4.3 1.69 5.6 3.18 2.48 2.84-5 3.58-6.73 3.86a.84.84 0 0 0 -.5 1.2c1.21 1.78 2.1 2.84 3.95 3.28a3.39 3.39 0 0 1 -2 2.61.85.85 0 0 0 .2 1.53 9.09 9.09 0 0 0 2.11.32c1.28 8.19 8.74 12.63 16.65 11.94 4.05-.35 5-1.66 6.71-5.55a14.2 14.2 0 0 0 .88-9.28zm-3.28 10.38c-2.06 3.17-5.55 3.23-9 2.65a12.63 12.63 0 0 1 -10.22-10.27 7.33 7.33 0 0 0 5.23-4.62c3.26 1.08 6.16 0 8.2-3a.85.85 0 0 0 -.5-1.23 23.24 23.24 0 0 0 -3.37-1h-.15a14.3 14.3 0 0 0 1.69-1.45l.14-.14a1 1 0 0 0 .29.1c4.48.61 8.3 4.83 9.4 9.05a12.92 12.92 0 0 1 -1.71 9.91z"
      fill="#4f2b1b"
    />
    <path
      d="m71.3 50.15c-1.13.43-2.57 0-3.71-.17-1-.15-1.4 1.35-.41 1.51 1.5.24 3.24.69 4.72.1s2.65-2.35 3.59-3.71a.76.76 0 0 0 -.28-1.06c-3.08-1.39-6.54-2-9.37.24a9.24 9.24 0 0 0 -1.72 1.87 18 18 0 0 0 -1.22-6.42c-.35-.93-1.86-.53-1.5.41a16.59 16.59 0 0 1 .75 9.73 9.93 9.93 0 0 0 -4.27-2.9c-5-1.69-8.1 2.36-9.33 6.74-1.32 4.67-1.93 12.65 2.37 16.15a6.07 6.07 0 0 0 6.33.84 6.32 6.32 0 0 0 5.49 2.6c5.42-.28 8.75-6.43 10.46-10.81 1.46-3.74 2.29-8.76-1.76-11.18a9.2 9.2 0 0 0 -7.85-.44 12.89 12.89 0 0 1 2.35-4.53c2.11-2.43 5-2.33 7.7-1.28a5.77 5.77 0 0 1 -2.34 2.31zm-2.4 5.28c4.41 1.19 3.51 5.8 2.21 9.12s-3.57 8.11-7.45 9.16c-1.74.47-4.26-.09-4.92-2a1.12 1.12 0 0 0 -1.84-.48c-1.75 1.43-4.27.39-5.45-1.21-2.77-3.75-1.81-11.22 0-15s5.45-4.52 8.41-1.53c1 1 .89 2.54 1.95 3.14a1.1 1.1 0 0 0 1.11 0l.76-.46a6.6 6.6 0 0 1 5.22-.74z"
      fill="#4f2b1b"
    />
    <rect
      fill="#85c441"
      height="23"
      rx="11.04"
      width="54.28"
      x="41.72"
      y="73"
    />
    <path
      d="m55.58 89.87c0-.37.1-3.27.11-3.62v-8.92c.07-.25.25-.25.44-.25a.54.54 0 0 1 .56.46v4.46l-.21 8.47a.62.62 0 0 1 -.52.23c-.25 0-.4-.41-.4-.6 0-.1.02-.23.02-.23z"
      fill="#fff"
    />
    <path
      d="m58.58 80.33v-.17c.23-1.21.77-3.2 2.12-3.2 2.12 0 2.52 1.85 2.7 3.64.07.67.22 2.5.22 2.62s-.15 2.68-.22 3.5c-.12 1.37-.68 3.32-2.32 3.32-1.08-.04-1.77-1.24-2.08-2.22a17.66 17.66 0 0 1 -.68-5.25 8.57 8.57 0 0 1 .26-2.24zm2.6 8.92c.78 0 1.18-2 1.27-2.53l.1-.87a16.76 16.76 0 0 0 .11-2.53 20.76 20.76 0 0 0 -.23-3.06c-.1-.85-.45-2.53-1.63-2.53-.45 0-1 1.75-1.1 2.1a12.42 12.42 0 0 0 -.44 2.52s0 .42 0 .57c-.01.96.32 6.33 1.92 6.33z"
      fill="#fff"
    />
    <path
      d="m65.53 80.33v-.17c.23-1.21.76-3.2 2.11-3.2 2.12 0 2.52 1.85 2.71 3.64.06.67.21 2.5.21 2.62s-.15 2.68-.21 3.5c-.08 1.37-.65 3.28-2.28 3.28-1.15 0-1.8-1.24-2.07-2.22a17.66 17.66 0 0 1 -.68-5.25 9 9 0 0 1 .21-2.2zm2.6 8.92c.79 0 1.19-2 1.27-2.53l.1-.87a15.58 15.58 0 0 0 .12-2.53 22.23 22.23 0 0 0 -.23-3.06c-.1-.85-.45-2.53-1.64-2.53-.45 0-1 1.75-1.1 2.1a12.41 12.41 0 0 0 -.43 2.52s0 .42 0 .57c-.02.96.31 6.33 1.91 6.33z"
      fill="#fff"
    />
    <path
      d="m75.64 81.71a2.12 2.12 0 0 1 -2.35 1.09c-1.72-.5-1-4.35.37-5.17 2.48-1.75 3.28 2.25 1.98 4.08zm-2.45-1.33c-.07.55-.1 1.87.83 1.64 1.14-.29 2-3.12 1-3.81s-1.75 1.62-1.83 2.17zm1.63 9.62c1.27-4.2 2.54-8.46 3.57-12.73a3.4 3.4 0 0 1 .1-.5h.22c.38 0 .55.2.55.58a11.47 11.47 0 0 1 -.77 2.92c-.95 3.3-1.82 6.76-2.9 10 0 .14-.12.29-.28.29-.35 0-.5-.09-.5-.38 0 .01.01-.18.01-.18zm6.72-.7a2 2 0 0 1 -2.35 1.08c-1.72-.5-.8-4.46.37-5.17 2.75-1.69 3.15 2.11 1.98 4.11zm-2.45-1.3c-.06.55-.1 1.86.84 1.63 1.13-.28 2-3.12 1-3.8s-1.75 1.61-1.84 2.17z"
      fill="#fff"
    />
  </svg>
</template>
